module.exports = __webpack_public_path__ + "img/flowersetting_04.a6c41a89.jpg";